/* eslint-disable react/jsx-one-expression-per-line */
// Copyright (c) 2020 Deere & Company

import './unauthorize.scss';
import PropTypes from 'prop-types';
import React from 'react';
import { withAuth } from '@okta/okta-react';

const Unauthorize = (props) => (
    <div className="unauthorize">

You are not authorized to perform this action. Your  session is terminated.
        <button type="button" className="button-text logout-button" style={{ fontSize: '20px' }} onClick={() => props.auth.logout()}>Please login again</button>
    </div>
);

Unauthorize.propTypes = {
    auth: PropTypes.object.isRequired,
};

export default withAuth(Unauthorize);
